<template>
    <div class="modal-dialog modal-lg w-100">
        <div class="modal-content">
            <div class="modal-header border-bottom-0 pb-0">
                <div class="text-center w-100">
                    <button type="button" class="btn btn-white float-end close-modal" @click.prevent="closeModal('dimension-filter-modal')" data-bs-toggle="tooltip" title="Close">
                        <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> 
                    </button>
                    <h3 class="mt-2">{{ action }} a User-Defined Filter</h3>
                </div>
            </div>
            <div class="modal-body pt-0 ">
                <div class="row">
                    <div class="col mb-3">
                        <label class="form-label">Filter Label</label>
                        <input type="text" id="filter-name-input" class="form-control" v-model="local_dimensional_filter.label"
                            :class="{ 'is-invalid': local_filter_errors.filter_label !== '' }" @change="clearErrorForField('filter_label')" aria-label="Filter Label">
                        <div class="text-danger invalid-feedback" v-if="local_filter_errors.filter_label !== ''">
                            {{local_filter_errors.filter_label}}
                        </div>
                    </div>

                    <div class="col mb-3">
                        <label class="form-label">Database Column Name</label>
                        <accordion-select v-model="local_dimensional_filter.column" :class="{ 'is-invalid': local_filter_errors.filter_column !== '' }"
                            :options="columns" @update:modelValue="loadDatabaseValues" @change="clearErrorForField('filter_column')"></accordion-select>
                        <div class="text-danger invalid-feedback" v-if="local_filter_errors.filter_column !== ''">
                            {{local_filter_errors.filter_column}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col mb-3">
                        <label class="form-label">Type</label>
                        <select class="form-select" :class="{ 'is-invalid': local_filter_errors.field_type !== '' }"
                        id="filter-type-select" v-model="local_dimensional_filter.field_type" @change="changeFieldType" aria-label="Type">
                            <option value="" disabled selected>Select the filter type...</option>
                            <option value="single_select">Single Select</option>
                            <option value="multi_select">Multiple Select</option>
                            <option value="array_single_select">Array Single Select</option>
                            <option value="array_multi_select">Array Multi-Select</option>
                            <option value="date_range">Date Range</option>
                            <option value="month_range">Month Range</option>
                            <option value="month_picker">Month Picker</option>
                            <option value="numeric_slider">Numeric Slider</option>
                        </select>
                        <div class="text-danger invalid-feedback" v-if="local_filter_errors.field_type !== ''">
                            {{local_filter_errors.field_type}}
                        </div>
                    </div>

                    <div class="col mb-3" >
                        <advanced-filter-dropdown v-if="local_dimensional_filter.field_type === 'single_select' || 
                            local_dimensional_filter.field_type === 'multi_select'|| 
                            local_dimensional_filter.field_type === 'array_single_select' ||
                            local_dimensional_filter.field_type === 'array_multi_select' ||
                            local_dimensional_filter.field_type === 'numeric_slider'" 
                            :class="{ 'is-invalid': local_filter_errors.default_value !== '' }"
                            :filter="local_dimensional_filter" @searchInLongOptionList="searchInLongOptionList" 
                            @updateFilter="updateDimensionalFilterDefaultValue"></advanced-filter-dropdown>

                        <template v-else-if="local_dimensional_filter.field_type === 'date_range'">
                            <label class="form-label">Default value type</label>
                            <div class="d-flex gap-3 mb-2">
                                <label class="form-label mb-0"><input type="radio" value="static" v-model="defaultValueType" @change="switchDateDefaultType('date_range', 'static')"> Static dates</label>
                                <label class="form-label mb-0"><input type="radio" value="relative" v-model="defaultValueType" @change="switchDateDefaultType('date_range', 'relative')"> Relative to today</label>
                            </div>
                            <div v-if="defaultValueType === 'static'" class="d-flex w-100">
                                <div class="me-3">
                                    <label class="form-label">Start Date</label>
                                    <datepicker-utc 
                                        v-model="local_dimensional_filter.default_value.start_date" 
                                        input-class="form-control date"
                                        input-format="M/d/yyyy"
                                    ></datepicker-utc>
                                </div>
                                <div>
                                    <label class="form-label">End Date</label>
                                    <datepicker-utc 
                                        v-model="local_dimensional_filter.default_value.end_date" 
                                        input-class="form-control date"
                                        input-format="M/d/yyyy"
                                    ></datepicker-utc>
                                </div>
                            </div>
                            <div v-else class="d-flex w-100">
                                <div class="me-3">
                                    <label class="form-label">Start</label>
                                    <select class="form-select" v-model="local_dimensional_filter.default_value.start" aria-label="Start">
                                        <option v-for="opt in relativeDateOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                                    </select>
                                </div>
                                <div>
                                    <label class="form-label">End</label>
                                    <select class="form-select" v-model="local_dimensional_filter.default_value.end" aria-label="End">
                                        <option v-for="opt in relativeDateOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                                    </select>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="local_dimensional_filter.field_type === 'month_range'">
                            <label class="form-label">Default value type</label>
                            <div class="d-flex gap-3 mb-2">
                                <label class="form-label mb-0"><input type="radio" value="static" v-model="defaultValueType" @change="switchDateDefaultType('month_range', 'static')"> Static months</label>
                                <label class="form-label mb-0"><input type="radio" value="relative" v-model="defaultValueType" @change="switchDateDefaultType('month_range', 'relative')"> Relative to today</label>
                            </div>
                            <div v-if="defaultValueType === 'static'" class="d-flex w-100">
                                <div class="me-3">
                                    <label class="form-label">Start Month</label>
                                    <datepicker-utc 
                                        v-model="local_dimensional_filter.default_value.start_date" 
                                        input-class="form-control date"
                                        input-format="M/yyyy"
                                        :monthPicker="true"
                                    ></datepicker-utc>
                                </div>
                                <div>
                                    <label class="form-label">End Month</label>
                                    <datepicker-utc 
                                        v-model="local_dimensional_filter.default_value.end_date" 
                                        input-class="form-control date"
                                        input-format="M/yyyy"
                                        :monthPicker="true"
                                    ></datepicker-utc>
                                </div>
                            </div>
                            <div v-else class="d-flex w-100">
                                <div class="me-3">
                                    <label class="form-label">Start</label>
                                    <select class="form-select" v-model="local_dimensional_filter.default_value.start" aria-label="Start">
                                        <option v-for="opt in relativeDateOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                                    </select>
                                </div>
                                <div>
                                    <label class="form-label">End</label>
                                    <select class="form-select" v-model="local_dimensional_filter.default_value.end" aria-label="End">
                                        <option v-for="opt in relativeDateOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                                    </select>
                                </div>
                            </div>
                        </template>

                        <div v-else-if="local_dimensional_filter.field_type === 'month_picker'">
                            <label class="form-label">Default Value</label>
                            <div v-if="local_dimensional_filter.options && local_dimensional_filter.options.includes('Loading Options...')">Loading Options...</div>
                            <div v-else class="row month-picker-grid mx-1">
                                <div v-for="month in local_dimensional_filter.options" :key="month" class="month-grid col-3 text-center py-2" @click="changeMonthValue(month)"
                                :class="{ 'month-grid-selected': local_dimensional_filter.default_value && Array.isArray(local_dimensional_filter.default_value) && local_dimensional_filter.default_value.includes(month) }">{{month}}</div>
                            </div>
                        </div>
                        
                        <div v-else>
                            <label class="form-label">Default Value</label>
                            <input type="text" class="form-control" :class="{ 'is-invalid': local_filter_errors.default_value !== '' }" :value="local_dimensional_filter.default_value" aria-label="Default Value">
                        </div>

                        <div class="text-danger invalid-feedback" v-if="local_filter_errors.default_value !== ''">
                            {{local_filter_errors.default_value}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col" v-if="show_group_name">
                        <div class="mb-3">
                            <label class="form-label">Group Name</label>
                            <select class="form-select"
                                :class="{ 'is-invalid': local_filter_errors.group_name !== '' }"
                                v-model="local_dimensional_filter.group_name"  @change="clearErrorForField('group_name')" aria-label="Group Name">
                                <option v-for="group in group_names" :key="group" :value="group">{{group}}</option>
                            </select>
                            <div class="text-danger invalid-feedback" v-if="local_filter_errors.group_name !== ''">
                                {{local_filter_errors.group_name}}
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3" :class="{ 'mt-4': show_group_name }">
                            <label class="form-label"><input class="form-check-input me-2" type="checkbox" v-model="local_dimensional_filter.is_required">Required for this report</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <button type="submit" class="btn btn-secondary" id="save-button"
                                @click.prevent="updateFilterWithinGroup"
                                :disabled="form.busy">
                            <i class="fa fa-plus"></i> {{ action }} Filter
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import vSelect from "vue3-select";

export default defineComponent({
    name: 'ReportBuilderUdfPopup',
    components: {
        Swal,
        vSelect
    },
    props: {
        dimensional_filter: {
            type: Object,
            required: false
        },
        action: {
            type: String,
            default: 'Add'
        },
        data_blend: {
            type: Object,
            required: false,
            default: null
        },
        metrics_filters: {
            type: Array,
            required: false
        },
        client_id: {
            type: [String, Number],
            required: false
        },
        show_group_name: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            local_dimensional_filter: null,
            local_metrics_filters: null,
            defaultValueType: 'static',
            relativeDateOptions: [
                { value: 'today', text: 'Today' },
                { value: 'yesterday', text: 'Yesterday' },
                { value: '1_week_ago', text: '1 week ago' },
                { value: '1_month_ago', text: '1 month ago' },
                { value: '1_year_ago', text: '1 year ago' },
                { value: '2_years_ago', text: '2 years ago' },
                { value: '3_years_ago', text: '3 years ago' }
            ],
            local_filter_errors: {
                filter_label: '',
                field_type: '',
                filter_column: '',
                default_value: '',
                group_name: ''
            },
            form: {
                successful: false,
                busy: false,
                error: false
            },
            group_names: [],
            columns: []
        };
    },
    beforeMount() {
        if(this.dimensional_filter != null) {
            this.local_dimensional_filter = JSON.parse(JSON.stringify(this.dimensional_filter));
            this.local_dimensional_filter.options = [];
            this.syncDefaultValueTypeFromFilter();
        } else {
            this.resetDimensionalFilter();
        }
            
        this.local_metrics_filters = this.metrics_filters;
        if(this.data_blend != null)
            this.refreshColumns();
    },
    watch: {
        dimensional_filter: {
            handler(newVal) {
                if(this.dimensional_filter != null) {
                    this.local_dimensional_filter = JSON.parse(JSON.stringify(this.dimensional_filter));
                    this.syncDefaultValueTypeFromFilter();
                } else {
                    this.resetDimensionalFilter();
                }

                this.loadDatabaseValues();
            },
            deep: true
        },
        data_blend: {
            handler() {
                this.refreshColumns();

                if(this.show_group_name) {
                    this.getGroupNames();
                }
            },
            deep: true
        }
    },
    methods: {
        refreshColumns() {
            if (!this.data_blend) return;
            
            const data = {
                include_trans: true,
                source: 'data_blend',
                data_source_id: this.data_blend.id
            };
            this.columns = [];

            window.axios.post('/api/bigquery/get_db_columns', data)
                .then(response => {
                    const cols = response.data.columns;
                    for(let i = cols.length - 1; i >= 0; i--) {
                        //If it is a custom column
                        if((this.client_id == null || this.client_id === "") && (cols[i].value.indexOf('custom.') >= 0 || cols[i].value.indexOf('ustom_calculations') > 0))
                            //Remove the column
                            cols.splice(i, 1);
                        else
                            cols[i].main_category = 'Columns';
                    }
                    this.columns = cols;
                    if(this.local_metrics_filters != null && this.local_metrics_filters.length > 0)
                        this.addCalculationsToColumnDropdown();
                    else
                        this.getMetricsFilters();
                });
        },
        getMetricsFilters() {
            if (!this.data_blend) return;
            
            window.axios.post('/api/metric_filter/list', {data_blend_id: this.data_blend.id})
                .then(response => {
                    this.local_metrics_filters = response.data.metrics_filters;
                    if(this.local_metrics_filters != null && this.local_metrics_filters.length > 0)
                        this.addCalculationsToColumnDropdown();
                });
        },
        getGroupNames() {
            window.axios.post('/api/metric_filter/group_names', {client_id: this.client_id})
                .then(response => {
                    this.group_names = response.data.group_names;
                    this.$forceUpdate();
                });
        },
        addCalculationsToColumnDropdown() {
            if (!this.data_blend) return;
            
            const metrics = [];

            this.local_metrics_filters.forEach(metric_filter_obj => {
                //If it is a specific client and that client isn't selected
                if(metric_filter_obj.data_blend_id != null && metric_filter_obj.data_blend_id != this.data_blend.id)
                    return;

                if (metric_filter_obj.type === 'dimension' && metric_filter_obj.data_blend_type === this.data_blend.type) {
                    metric_filter_obj.main_category = 'Dimensions';
                    metric_filter_obj.value = metric_filter_obj.id;
                    metric_filter_obj.text = metric_filter_obj.admin_name;
                    metrics.push(metric_filter_obj);
                }
            });
            this.columns = this.columns.concat(metrics);
            this.$forceUpdate();
        },
        resetDimensionalFilter() {
            this.local_dimensional_filter = {
                label: 'Default Value',
                field_type: '',
                is_required: false,
                column: null,
                default_value: [],
                order: null,
                group_name: '',
                options: []
            };
        },
        loadDatabaseValues() {
            if (!this.data_blend) return;

            if(this.local_dimensional_filter.column == null) {
                this.local_dimensional_filter.options = [];
                return;
            }
            //Don't get DB values for a numeric slider, get the min/max
            else if(this.local_dimensional_filter.field_type === 'numeric_slider') {
                this.getMinMax();
                return;
            }

            const data = {
                source: 'data_blend',
                column: typeof this.local_dimensional_filter.column === 'object' ? this.local_dimensional_filter.column.value : this.local_dimensional_filter.column,
                limit: 1000,
                data_source_id: this.data_blend.id,
                staging_table: false
            };

            if(this.local_dimensional_filter.field_type === 'single_select' || this.local_dimensional_filter.field_type === 'multi_select' || this.local_dimensional_filter.field_type === 'array_single_select' || this.local_dimensional_filter.field_type === 'array_multi_select') {
                //Don't add it if it is already loading the options
                if(!this.local_dimensional_filter.options)
                    this.local_dimensional_filter.options = [];
                if (!this.local_dimensional_filter.options.includes("Loading Options..."))
                    this.local_dimensional_filter.options.push("Loading Options...");
            }

            window.axios.post('/api/bigquery/get_samples', data)
                .then(response => {
                    this.local_dimensional_filter.options = [];
                    
                    //Remove the null value
                    for(let i = response.data.samples.length - 1; i >= 0; i--) {
                        if(response.data.samples[i].name == null)
                            response.data.samples.splice(i, 1);
                        else {
                            this.local_dimensional_filter.options.push(response.data.samples[i].name);                 
                        }                        
                    }

                    if (this.local_dimensional_filter.field_type === 'month_picker') {
                        // sort by month order
                        const monthOrder = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                        this.local_dimensional_filter.options.sort((a, b) => monthOrder.indexOf(a) > monthOrder.indexOf(b) ? 1 : -1);
                    } else {
                        this.local_dimensional_filter.options.sort((a, b) => (a.name > b.name) ? 1 : -1); 
                    }

                    //Make a copy of the local_dimensional_filter object to trigger the filter refresh
                    const filter = JSON.parse(JSON.stringify(this.local_dimensional_filter));
                    if(Number(filter.column) && Number(filter.column) > 0){
                        filter.column = this.columns.find((option) => option.value === Number(filter.column));
                    }
                    this.local_dimensional_filter = filter;

                    this.$forceUpdate();
                });
        },
        getMinMax() {
            const data = {
                source: 'data_blend',
                column: this.local_dimensional_filter.column,
                data_source_id: this.data_blend.id,
            };

            if(this.local_dimensional_filter.options && this.local_dimensional_filter.options.length === 2) {
                //Verify they are both numbers
                if(!isNaN(this.local_dimensional_filter.options[0]) && !isNaN(this.local_dimensional_filter.options[1])) {
                    //Temporarily set it to the default values
                    this.local_dimensional_filter.slider_max = this.local_dimensional_filter.options[1];
                    this.local_dimensional_filter.slider_min = this.local_dimensional_filter.options[0];
                } else {
                    this.local_dimensional_filter.slider_max = 1;
                    this.local_dimensional_filter.slider_min = 0;
                    this.local_dimensional_filter.options = [0, 1];
                }
            } else {
                //Just set it to 0 and 1 for now until the data can be pulled
                this.local_dimensional_filter.slider_max = 1;
                this.local_dimensional_filter.slider_min = 0;
                this.local_dimensional_filter.options = [0, 1];
            }

            window.axios.post('/api/bigquery/get_min_max', data)
                .then(response => {
                    if (typeof response.data === 'object' && response.data.min !== undefined && response.data.max !== undefined) {
                        // Direct min/max values from API
                        this.local_dimensional_filter.slider_min = Math.floor(response.data.min);
                        this.local_dimensional_filter.slider_max = Math.ceil(response.data.max);
                    } else if (Array.isArray(response.data)) {
                        // Array of values to process
                        const value = response.data.reduce((accumulator, current) => {
                            accumulator.push(parseInt(current.name));
                            return accumulator;
                        }, []);
                        this.local_dimensional_filter.slider_min = Math.floor(Math.min(...value));
                        this.local_dimensional_filter.slider_max = Math.ceil(Math.max(...value));
                        this.local_dimensional_filter.options = [];
                        this.local_dimensional_filter.options.push(this.local_dimensional_filter.slider_min);
                        this.local_dimensional_filter.options.push(this.local_dimensional_filter.slider_max);
                    }

                    if(this.local_dimensional_filter.options && this.local_dimensional_filter.options.length === 2 && !isNaN(this.local_dimensional_filter.options[0]) && !isNaN(this.local_dimensional_filter.options[1])) {
                        if(this.local_dimensional_filter.options[0] < this.local_dimensional_filter.slider_min)
                            this.local_dimensional_filter.slider_min = this.local_dimensional_filter.options[0];
                        if(this.local_dimensional_filter.options[1] > this.local_dimensional_filter.slider_max)
                            this.local_dimensional_filter.slider_max = this.local_dimensional_filter.options[1];
                    }
                    //Make a copy of the local_dimensional_filter object to trigger the filter refresh
                    const filter = JSON.parse(JSON.stringify(this.local_dimensional_filter));
                    this.local_dimensional_filter = filter;
                    this.$forceUpdate();
                });
        },
        updateDimensionalFilterDefaultValue(value_details) {
            this.clearErrorForField('default_value');
            this.local_dimensional_filter.default_value = value_details.filter_value;
        },
        isEngagementMetricArrayFilter() {
            if (!this.data_blend || this.data_blend.type !== 'engagement') return false;
            if (this.local_dimensional_filter.field_type !== 'single_select') return false;
            const col = this.local_dimensional_filter.column;
            const columnStr = typeof col === 'object' && col && col.value != null ? String(col.value) : (col != null ? String(col) : '');
            if (!columnStr || /^\d+$/.test(columnStr)) return false;
            const prefixes = ['cost_metrics.', 'impression_metrics.', 'session_metrics.', 'click_metrics.', 'email_metrics.', 'revenue_metrics.', 'other_metrics.'];
            return prefixes.some(prefix => columnStr.startsWith(prefix));
        },
        hasErrors() {
            //validate the form
            if(this.local_dimensional_filter.label == null || this.local_dimensional_filter.label === "") {
                this.local_filter_errors.filter_label = "A filter label is required.";
            } else {
                this.local_filter_errors.filter_label = "";
            }

            if(this.local_dimensional_filter.field_type == null || this.local_dimensional_filter.field_type === "") {
                this.local_filter_errors.field_type = "A filter type is required.";
            } else {
                this.local_filter_errors.field_type = "";
            }

            if(this.local_dimensional_filter.column == null || this.local_dimensional_filter.column === "") {
                this.local_filter_errors.filter_column = "A database column is required.";
            } else {
                this.local_filter_errors.filter_column = "";
            }

            const skipDefaultValueForEngagement = this.isEngagementMetricArrayFilter();
            if (this.local_dimensional_filter.is_required && !skipDefaultValueForEngagement && (this.local_dimensional_filter.field_type === 'date_range' || this.local_dimensional_filter.field_type === 'month_range')) {
                const dv = this.local_dimensional_filter.default_value;
                const hasStatic = dv && (dv.start_date || dv.end_date);
                const hasRelative = dv && dv.type === 'relative' && dv.start && dv.end;
                if (!hasStatic && !hasRelative) {
                    this.local_filter_errors.default_value = "You must select default value for a required filter";
                } else {
                    this.local_filter_errors.default_value = "";
                }
            } else if(this.local_dimensional_filter.is_required && !skipDefaultValueForEngagement && (this.local_dimensional_filter.default_value == null || this.local_dimensional_filter.default_value.length === 0)) {
                this.local_filter_errors.default_value = "You must select default value for a required filter";
            } else {
                this.local_filter_errors.default_value = "";
            }

            if(this.show_group_name && (this.local_dimensional_filter.group_name == null || this.local_dimensional_filter.group_name === '')) {
                this.local_filter_errors.group_name = "You must select a group name";
            } else {
                this.local_filter_errors.group_name = "";
            }

            return this.local_filter_errors.filter_label !== "" || 
                   this.local_filter_errors.field_type !== "" ||
                   this.local_filter_errors.filter_column !== "" || 
                   this.local_filter_errors.default_value !== "" || 
                   this.local_filter_errors.group_name !== "";
        },
        updateFilterWithinGroup() {
            this.clearErrors();
            if(this.hasErrors()) {
                return;
            }
            if(this.local_dimensional_filter.field_type === 'month_range' || this.local_dimensional_filter.field_type === 'date_range') {
                const dv = this.local_dimensional_filter.default_value;
                if (dv && dv.type === 'relative') {
                    this.local_dimensional_filter.default_value = { type: 'relative', start: dv.start || 'today', end: dv.end || 'today' };
                } else {
                    this.local_dimensional_filter.default_value.start_date = this.local_dimensional_filter.default_value.start_date ? moment(String(this.local_dimensional_filter.default_value.start_date)).utc().format('YYYY-MM-DD'): null;
                    this.local_dimensional_filter.default_value.end_date = this.local_dimensional_filter.default_value.end_date ? moment(String(this.local_dimensional_filter.default_value.end_date)).utc().format('YYYY-MM-DD'): null;
                }
            } else if(this.local_dimensional_filter.field_type === 'numeric_slider') {
                //If the min and max are the same, just wipe the default value
                if(this.local_dimensional_filter.default_value && 
                    this.local_dimensional_filter.default_value[0] === this.local_dimensional_filter.slider_min && 
                    this.local_dimensional_filter.default_value[1] === this.local_dimensional_filter.slider_max)
                    this.local_dimensional_filter.default_value = null;
            }

            this.$emit('updateFilterWithinGroup', this.local_dimensional_filter);
            this.resetDimensionalFilter();
        },
        changeMonthValue(month) {
            if (this.local_dimensional_filter.default_value.includes(month)) {
                this.local_dimensional_filter.default_value = this.local_dimensional_filter.default_value.filter((m) => m !== month);
            } else {
                this.local_dimensional_filter.default_value.push(month);
            }
        },
        searchInLongOptionList(search_details) {
            const data = {
                client: this.client,
                source: 'data_blend',
                column: typeof filter.column === 'object' ? filter.column.value : filter.column,
                limit: 1000,
                data_source_id: this.pages_selected[0].data_blend.id,
                staging_table: false,
                search: search_details.search_key
            };
            window.axios.post('/api/bigquery/get_samples', data)
                .then(response => {
                    this.local_dimensional_filter.options = [];
                    
                    //Remove the null value
                    for(let i = response.data.samples.length - 1; i >= 0; i--) {
                        if(response.data.samples[i].name == null)
                            response.data.samples.splice(i, 1);
                        else {
                            this.local_dimensional_filter.options.push(response.data.samples[i].name);                 
                        }
                    }
                    //No way a long seach can be a month picker
                    this.local_dimensional_filter.options.sort((a, b) => (a.name > b.name) ? 1 : -1); 
                    this.local_dimensional_filter = JSON.parse(JSON.stringify(this.local_dimensional_filter));
                    this.$forceUpdate();
                });
        },
        changeFieldType() {
            this.clearErrorForField('field_type');
            if (this.local_dimensional_filter.field_type === 'date_range' || this.local_dimensional_filter.field_type === 'month_range') {
                this.defaultValueType = 'static';
                this.local_dimensional_filter.default_value = {
                    start_date: null,
                    end_date: null
                };
            } 
            if (this.local_dimensional_filter.field_type === 'single_select') {
                this.local_dimensional_filter.default_value = null;
            } 
            if (this.local_dimensional_filter.field_type === 'multi_select') {
                this.local_dimensional_filter.default_value = [];
            }
            if (this.local_dimensional_filter.field_type === 'array_single_select') {
                this.local_dimensional_filter.default_value = [];
            }
            if (this.local_dimensional_filter.field_type === 'array_multi_select') {
                this.local_dimensional_filter.default_value = [];
            }
            if (this.local_dimensional_filter.field_type === 'month_picker') {
                this.local_dimensional_filter.default_value = [];
                
            } 
            if (this.local_dimensional_filter.field_type === 'numeric_slider') {
                this.getMinMax();
            } 

            this.$forceUpdate();
        },
        syncDefaultValueTypeFromFilter() {
            if (!this.local_dimensional_filter || (this.local_dimensional_filter.field_type !== 'date_range' && this.local_dimensional_filter.field_type !== 'month_range')) {
                return;
            }
            const dv = this.local_dimensional_filter.default_value;
            if (dv && dv.type === 'relative') {
                this.defaultValueType = 'relative';
                if (!dv.start) this.local_dimensional_filter.default_value.start = 'today';
                if (!dv.end) this.local_dimensional_filter.default_value.end = 'today';
            } else {
                this.defaultValueType = 'static';
                if (!dv || typeof dv !== 'object' || !('start_date' in dv)) {
                    this.local_dimensional_filter.default_value = { start_date: null, end_date: null };
                }
            }
        },
        switchDateDefaultType(fieldType, type) {
            this.defaultValueType = type;
            if (type === 'relative') {
                this.local_dimensional_filter.default_value = { type: 'relative', start: 'today', end: 'today' };
            } else {
                this.local_dimensional_filter.default_value = { start_date: null, end_date: null };
            }
        },
        clearErrorForField(field_name) {
            this.local_filter_errors[field_name] = '';
        },
        clearErrors() {
            //reset errors to empty strings
            this.local_filter_errors = {
                filter_name: '',
                field_type: '',
                filter_column: '',
                default_value: '',
                group_name: ''
            };
        },
        closeModal(modal_ID) {
            this.resetDimensionalFilter();
            const myModalEl = document.getElementById(modal_ID);
            const modal = bootstrap.Modal.getInstance(myModalEl);
            modal.hide();
        }
    }
});
</script>
